import type { Permission } from "@@/shared/auth/scopes/permission";
import {
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import type { EntityState } from "@@/shared/entity-status";
import type { ProviderId } from "@@/shared/providers/provider-id";
import type { Except } from "type-fest";
import type { UserId } from "../user-id";
import { invitationIdFactory, type InvitationId } from "./invitation-id";

type InvitationStatus = {
    status: "SENT" | "CREATED" | "ACCEPTED";
    _createdAt: IsoAndUnixTimestamp;
};

type Invitation = {
    _id: InvitationId;
    _type: "INVITATION";
    _status: EntityState;
    inviteType: "PROVIDER_INVITE";
    phone?: string;
    providerId: ProviderId;
    email: string;

    permission: Permission; //Should be many?
    status: InvitationStatus[];
    _createdAt: IsoAndUnixTimestamp;
    validUntil: IsoAndUnixTimestamp;
    createdBy: UserId;
};

type FactoryParams = Except<
    Invitation,
    "_id" | "_type" | "_createdAt" | "_status"
>;
const invitationFactory = (params: FactoryParams) => {
    const now = nowIsoAndUnix();
    const command: Invitation = {
        ...params,
        _id: invitationIdFactory(),
        _type: "INVITATION",
        _status: "ACTIVE",
        inviteType: "PROVIDER_INVITE",
        _createdAt: now,
        status: [{ _createdAt: now, status: "CREATED" }],
    };
    return command;
};

export { invitationFactory };
export type { Invitation };
